import exponent from'./exponent';const precisionFixed=a=>Math.max(0,-exponent(Math.abs(a)));export default precisionFixed;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-utils/src/number-converter/precision-fixed.js
// module id = null
// module chunks = 